export const SET_ACTIVE_LANGUAGE = 'SET_ACTIVE_LANGUAGE';

export const setActiveLanguage = ({ activeLanguage }: { activeLanguage: string }) => ({
    type: SET_ACTIVE_LANGUAGE,
    payload: { activeLanguage },
});
